var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideoCallCircle70(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "21px",
    viewBox: "0 0 30 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icVideoCallCircle70") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop--Callback",
    transform: "translate(-870.000000, -612.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(16.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(638.000000, 388.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246,34.8271335 L246,48.1597374 C246,49.190372 244.95556,49.833698 244.120008,49.321663 L238.922384,46.1181619 L238.922384,47.0306346 C238.922384,49.7746171 236.839648,52 234.271554,52 L220.650829,52 C218.082736,52 216,49.7746171 216,47.0306346 L216,35.9693654 C216,33.2253829 218.082736,31 220.650829,31 L234.277698,31 C236.845792,31 238.928528,33.2253829 238.928528,35.9693654 L238.928528,36.8818381 L244.126152,33.678337 C244.95556,33.1531729 246,33.8030635 246,34.8271335 Z",
    id: "icVideoCallCircle70"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoCallCircle70);
export default __webpack_public_path__ + "static/media/icVideoCallCircle70.add518952b9826b92b1d67ea6e1ee137.svg";
export { ForwardRef as ReactComponent };